import { CookieConsentResponseSchema, } from '@resida/api-types/cookie-consent';
/**
 * Builds an app's cookie-consent server client (BR-11, BR-12) from its endpoint path and its
 * authenticated fetch. Responses are validated against the boundary schema in @resida/api-types.
 */
export function createCookieConsentApi({ path, apiFetch, }) {
    const call = async (init) => CookieConsentResponseSchema.parse(await apiFetch(path, init));
    return {
        fetchServerConsent: async () => (await call()).consent,
        putServerConsent: async (body) => {
            await call({ method: 'PUT', body: JSON.stringify(body) });
        },
    };
}
//# sourceMappingURL=createCookieConsentApi.js.map